
/**
 * 수강신청 유형
 */
export type EnrollmentInfoEnrollmentType = typeof EnrollmentInfoEnrollmentType[keyof typeof EnrollmentInfoEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentInfoEnrollmentType = {
  REGULAR: 'REGULAR',
  AUDIT: 'AUDIT',
  PREMIUM: 'PREMIUM',
  TRIAL: 'TRIAL',
} as const;
